import React from "react";
import { MdClose } from "react-icons/md";
import { exitFullscreen } from "../kiosk/component/function/kiosk";
import { useNavigate } from "react-router";

import { StoreMenu } from "./component/styled/common";
import { CloseButton, Container } from "../kiosk/component/styled/common";

const Menus = ({ setActiveMenu }) => {
  const navigate = useNavigate();
  const menus = [
    { key: "pickup", tit: "주문", imagePath: "cafe" },
    { key: "salesCheck", tit: "매출확인", imagePath: "salesCheck_salesCheck" },
    { key: "review", tit: "리뷰", imagePath: "invoice" },
    { key: "setting", tit: "상점관리", imagePath: "menu" },
  ];

  const exitKioskPage = () => {
    sessionStorage.removeItem("store");
    exitFullscreen();
    navigate("/mypage");
  };

  return (
    <Container className="bg">
      <CloseButton>
        <button onClick={exitKioskPage}>
          <MdClose />
        </button>
      </CloseButton>
      <StoreMenu>
        {menus.map((item) => (
          <li
            className={item.key}
            onClick={() => {
              // if (item.key === "setting") {
              //   alert("준비중입니다.");
              //   return;
              // }
              setActiveMenu(item.key);
              window.location.hash = `#${item.key}`;
            }}>
            <div className="box">
              <div className="image">
                <img src={`/img/store/${item.imagePath}.png`} alt="" />
              </div>
              <span>{item.tit}</span>
            </div>
          </li>
        ))}
      </StoreMenu>
    </Container>
  );
};

export default Menus;
